<template>
  <div
    v-resize="onResize"
    v-touch="{ right: swipeRight, left: swipeLeft }"
    :class="[{
      'c-page--active': active,
      'c-page--reverse': reverse,
      'c-page--has-top': $scopedSlots.top,
      'c-page--full-content': fullContent,
      'c-page--small-sidebar': smallSidebar,
      'c-page--hide-sidebar': !$scopedSlots.sidebar,
      'c-page--hide-content': !$scopedSlots.content,
    }, $scopedSlots.sidebar && $scopedSlots.content ? `c-page--animation-${animation}` : '']"
    class="c-page c-page--is-component">
    <div v-if="loading" key="loading" class="c-page__loading">
      <v-progress-circular color="primary" size="80" indeterminate />
    </div>
    <div v-else-if="error || errorMessage" class="c-page__error">
      <slot v-if="$scopedSlots.error && !errorMessage" name="error"></slot>
      <div v-else class="c-page__error__content">
        <span>{{ errorMessage || 'Error' }}</span>
      </div>
    </div>
    <template v-else>
      <div v-if="$scopedSlots.top" ref="top" key="top" v-mutate="onResize" class="c-page__top">
        <slot name="top"></slot>
      </div>
      <div
        v-if="$scopedSlots.sidebar || $scopedSlots.content"
        key="wrapper"
        :class="contentAlign && `c-page__wrapper--${contentAlign}`"
        class="c-page__wrapper">
        <div ref="sidebar" class="c-page__sidebar">
          <slot name="sidebar" :sidebar-style="'c-page__sidebar-style'"></slot>
        </div>
        <div ref="content" class="c-page__content">
          <slot name="content" :sidebar-sryle="'c-page__sidebar-style'"></slot>
        </div>
      </div>
      <slot name="default"></slot>
    </template>
  </div>
</template>

<script>
export default {
  name: 'CPage',
  props: {
    value: { type: [String, Number, Boolean, Array, Object, Date, Function, Symbol], default: '' },
    contentAlign: { type: String, default: '' },
    animation: { type: String, default: 'default' },
    smallSidebar: { type: Boolean, default: false },
    fullContent: { type: Boolean, default: false },
    reverse: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    mobileBreakpoint: { type: Number, default: 800 },
    error: { type: Boolean, default: false },
    errorMessage: { type: String, default: '' },
  },
  model: {
    event: 'change',
  },
  data() {
    return {
      topHeight: 0,
      active: false,
    };
  },
  created() {
    this.$watch('value', value => this.active = !!value, { immediate: true });
  },
  updated() {
    this.onResize();
  },
  methods: {
    onResize() {
      if (window.innerWidth <= this.mobileBreakpoint) {
        if (this.$refs.top && this.topHeight !== this.$refs.top.clientHeight) {
          this.topHeight = this.$refs.top.clientHeight;
          this.setPaddingTop(this.topHeight);
        }
      } else if (this.topHeight) {
        this.topHeight = 0;
        this.setPaddingTop(this.topHeight);
      }
    },
    setPaddingTop(paddingTop) {
      if (paddingTop) {
        if (this.$scopedSlots.sidebar && this.$scopedSlots.content) {
          if (this.animation === 'fixed-sidebar') this.$refs.content.style.paddingTop = `${this.topHeight && this.topHeight + 20}px`;
          else this.$refs.sidebar.style.paddingTop = `${this.topHeight && this.topHeight + 20}px`;
        } else if (this.$scopedSlots.sidebar) {
          this.$refs.sidebar.style.paddingTop = `${this.topHeight && this.topHeight + 20}px`;
        } else if (this.$scopedSlots.content) {
          this.$refs.content.style.paddingTop = `${this.topHeight && this.topHeight + 20}px`;
        }
      } else {
        this.$refs.sidebar.style.paddingTop = '';
        this.$refs.content.style.paddingTop = '';
      }
    },
    swipeRight() {
      if (window.innerWidth <= this.mobileBreakpoint) {
        if (this.reverse) {
          if (this.active) this.active = false;
          this.$emit('change', null);
          this.$emit('open:content', true);
        } else {
          this.active = true;
          this.$emit('change', true);
          this.$emit('open:sidebar', true);
        }
      }
    },
    swipeLeft() {
      if (window.innerWidth <= this.mobileBreakpoint) {
        if (this.reverse) {
          this.active = true;
          this.$emit('change', true);
          this.$emit('open:sidebar', true);
        } else if (this.active) {
          this.active = false;
          this.$emit('change', null);
          this.$emit('open:content', true);
        }
      }
    },
  },
};
</script>
